/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Aicostsunpriced2Inputs */

const en_aicostsunpriced2 = /** @type {(inputs: Aicostsunpriced2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} without a price`)
};

const de_aicostsunpriced2 = /** @type {(inputs: Aicostsunpriced2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ohne Preis`)
};

/**
* | output |
* | --- |
* | "{count} without a price" |
*
* @param {Aicostsunpriced2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostsunpriced2 = /** @type {((inputs: Aicostsunpriced2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostsunpriced2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostsunpriced2(inputs)
	return de_aicostsunpriced2(inputs)
});
export { aicostsunpriced2 as "aiCostsUnpriced" }